import { ClientRestrictionStatus } from "./ClientRestrictionStatus";
import { Utilities as utilities } from "@truckdown/framework";

export class UpdateRestrictionModel {
    constructor(json?: any) {
        if (json) {
            this.key = utilities.json.getStringValue(json, "key", '');
            this.status = utilities.json.getEnumValue(json, "s", ClientRestrictionStatus, ClientRestrictionStatus.None);
            this.note = utilities.json.getStringValue(json, "n", '');
            if (json.exp) {
                this.expiry = utilities.json.getDateValue(json, 'exp');
            }
        }
    }

    toJSON() {
        return {
            key: this.key,
            s: this.status,
            n: this.note,
            exp: this.expiry
        };
    }

    key: string = '';
    status: ClientRestrictionStatus = ClientRestrictionStatus.None;
    note: string = '';
    expiry?: Date;
}